import { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { toast } from "sonner";

export default function SuperPlans() {
  const [plans, setPlans] = useState([]);
  const load = () => api.get("/super/plans").then((r) => setPlans(r.data));
  useEffect(() => { load(); }, []);

  const toggleActive = async (p) => {
    await api.put(`/super/plans/${p.id}`, { is_active: !p.is_active });
    toast.success("Updated"); load();
  };

  return (
    <div data-testid="super-plans">
      <div className="admin-overline">Pricing</div>
      <h1 className="admin-heading text-3xl font-bold mt-1 mb-6">Subscription plans</h1>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-px bg-neutral-200 border border-neutral-200">
        {plans.map((p) => (
          <div key={p.id} className="p-4 sm:p-6 bg-white min-w-0" data-testid={`super-plan-${p.code}`}>
            <div className="flex justify-between items-start gap-3">
              <div className="min-w-0">
                <div className="admin-overline">{p.code}</div>
                <div className="admin-heading text-2xl font-bold mt-1">{p.name}</div>
                <div className="text-xs text-neutral-500 mt-1 leading-relaxed">{p.description}</div>
              </div>
              <button onClick={() => toggleActive(p)} className={`flex-shrink-0 px-3 py-2 text-[10px] uppercase tracking-wider font-semibold ${p.is_active ? "bg-black text-white" : "bg-neutral-200"}`} data-testid={`super-plan-toggle-${p.code}`}>
                {p.is_active ? "Active" : "Off"}
              </button>
            </div>
            <div className="mt-5 space-y-1">
              <div className="flex justify-between text-sm"><span className="text-neutral-500">Monthly</span><span className="font-mono font-semibold">{formatINR(p.price_monthly)}</span></div>
              <div className="flex justify-between text-sm"><span className="text-neutral-500">Quarterly</span><span className="font-mono font-semibold">{formatINR(p.price_quarterly)}</span></div>
              <div className="flex justify-between text-sm"><span className="text-neutral-500">Yearly</span><span className="font-mono font-semibold">{formatINR(p.price_yearly)}</span></div>
              {p.trial_days > 0 && <div className="flex justify-between text-sm"><span className="text-neutral-500">Trial</span><span className="font-mono">{p.trial_days} days</span></div>}
            </div>
            <div className="mt-5 pt-4 border-t border-neutral-200 grid grid-cols-2 gap-1.5 text-xs text-neutral-700">
              <div>Sellers: <b>{p.features.max_sellers}</b></div>
              <div>Services: <b>{p.features.max_services}</b></div>
              <div>Bookings/mo: <b>{p.features.max_bookings_per_month}</b></div>
              <div>Online pay: <b>{p.features.online_payment ? "Yes" : "No"}</b></div>
              <div>Custom domain: <b>{p.features.custom_domain ? "Yes" : "No"}</b></div>
              <div>Coupons: <b>{p.features.coupons ? "Yes" : "No"}</b></div>
              <div>Reports: <b>{p.features.reports ? "Yes" : "No"}</b></div>
              <div>WhatsApp: <b>{p.features.whatsapp_integration ? "Yes" : "No"}</b></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
